const ChannelActions = {
  ARCHIVE: 'ARCHIVE',
  UNARCHIVE: 'UNARCHIVE',
  HIDE: 'HIDE',
  SHOW: 'SHOW',
};

const channelActionConfig = {
  [ChannelActions.ARCHIVE]: {
    label: 'Archive',
    alert: {
      header: 'Archive Chat',
      message: 'Are you sure you want to archive your chat with {channelName}?',
    },
  },
  [ChannelActions.UNARCHIVE]: {
    label: 'Unarchive',
    alert: {
      header: 'Unarchive Chat',
      message: 'Are you sure you want to unarchive your chat with {channelName}?',
    },
  },
  [ChannelActions.HIDE]: {
    label: 'Hide',
    alert: {
      header: 'Hide Chat',
      message: "Are you sure you want to hide your chat with {channelName}? It will be available in the 'All' tab",
    },
  },
  [ChannelActions.SHOW]: {
    label: 'Show',
    alert: {
      header: 'Show Chat',
      message: "Are you sure you want to show your chat with {channelName}? It will be available in the 'Active' tab",
    },
  },
};

export {
  ChannelActions,
  channelActionConfig,
};
